import { Grid, styled } from "@mui/material";

export const TableHead = styled(Grid)({
  border: "solid 1px #4EAF51",
  height: "60px",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  padding: "0px 5px",
  marginBottom: "10px",
});
export const TableRow = styled(Grid)({
  height: "60px",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  padding: "0px 5px",
  marginTop: "5px",
  display: "flex",
  alignItems: "center",
});
